import request from '@/utils/request'
export function getInfo(params) {  //数据接口
  return request({
    url: '/api/v1/index',
    method: 'get',
    params
  })
}
export function getMoreList(params) {  //查看更多
  return request({
    url: '/api/v1/index/more-list',
    method: 'get',
    params
  })
}
export function geInfoDetail(params) {  //文章详情
  return request({
    url: '/api/v1/index/article-view',
    method: 'get',
    params
  })
}
export function getFooter(params) {  //页脚信息
  return request({
    url: '/api/v1/index/footer',
    method: 'get',
    params
  })
}
export function putOnline(params) {  //留言
  return request({
    url: '/api/v1/index/online-message',
    method: 'get',
    params
  });
}

export function getPartnerRecruit(params) {  // 合伙人招募
  return request({
    url: '/api/v1/index/partner-recruit',
    method: 'post',
    params
  });
}

export function getSupplierRecruit(params) {  // 供应商招募
  return request({
    url: '/api/v1/index/supplier-recruit',
    method: 'post',
    params
  });
}

export function getComplaintsSuggestions(params) {  // 投诉与建议
  return request({
    url: '/api/v1/index/complaints-suggestions',
    method: 'post',
    params
  });
}


// WEBPACK FOOTER //
// ./src/api/api.js